var FormMessageStyle = function(theme) {
    return {
        outerContainer: {
            default: {
                fontFamily: theme.font.base.family,
                fontSize: theme.font.base.size[2],
                fontStyle: 'normal',
                fontWeight: theme.font.base.weight.regular,
                letterSpacing: 'normal',
                lineHeight: theme.font.lineHeight.base,
                textIndent: 0,
                textShadow: 'none',
                textTransform: 'none',
                display: 'block',
                margin: '0.25rem 0 0',
                padding: 0,
                verticalAlign: 'top'
            },
            messageType: {
                info: {
                    color: theme.font.color.soft
                },
                error: {
                    color: theme.font.color.danger.base
                }
            },
            textDirection: {
                ltr: {
                    textAlign: 'left',
                    direction: 'ltr'
                },
                rtl: {
                    textAlign: 'right',
                    direction: 'rtl'
                }
            }
        },
        errorIconContainer: {
            default: {
                verticalAlign: 'middle',
                position: 'relative',
                top: '2px'
            },
            textDirection: {
                ltr: {
                    paddingRight: '5px'
                },
                rtl: {
                    paddingLeft: '5px'
                }
            }
        }
    };
};
export default FormMessageStyle;
